import { rm } from 'utils';
import styles from './styles.scss';
import connect from 'components/Shared/connect';
import { getCartItemQuantity, getCheckoutLink } from 'components/Basket/selector';
import { basketClose, basketOpen } from 'components/Basket/actions';
import { CartItem } from 'models/CartItem';
import { Summary } from './summary';
import { CartItemRow } from './cartItem';
import { useEffect, useRef, useCallback } from 'react';
import { getCurrentModalElement } from 'components/Shared/Modal';
import { BasketButton } from 'components/Basket/basketButton/themes/BGH';
import { useDispatch } from 'react-redux';
import { GtmViewBasket } from 'store/googleTagManager/actions';

interface OwnProps {
  className?: string;
}

interface MergedProps extends OwnProps {
  quantity: number;
  url: string;
  isOpen: boolean;
  open: () => void;
  close: () => void;
  cartItems: CartItem[];
}

const _DesktopBasket = ({
  className,
  quantity,
  url,
  isOpen,
  open,
  close,
  cartItems
}: MergedProps) => {
  const reduxDispatch = useDispatch();
  const ref = useRef<HTMLDivElement>(null);
  const handleClick = useCallback(
    (event: MouseEvent) => {
      if (event.target !== null && event.target instanceof Node) {
        const modalElem = getCurrentModalElement();
        const isClickOutside = ref.current && !ref.current.contains(event.target);
        const isModalClick = modalElem && modalElem.contains(event.target);

        if (isClickOutside && !isModalClick) {
          close();
        }
      }
    },
    [close]
  );

  useEffect(() => {
    if (isOpen) {
      document.addEventListener('mousedown', handleClick);
    } else {
      document.removeEventListener('mouseDown', handleClick);
    }

    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [isOpen, handleClick]);

  const handleOnMouseEnter = () => {
    reduxDispatch(GtmViewBasket());

    open();
  };

  return (
    <div ref={ref} onMouseEnter={handleOnMouseEnter} onMouseLeave={close} className={styles.base}>
      <BasketButton url={url} quantity={quantity} className={className} />
      {isOpen && (
        <div className={styles.dropdown}>
          <div className={styles.header}>{rm('shared_minibasket_name')}</div>
          <ul className={styles.cartItems}>
            {cartItems.map(item => (
              <CartItemRow key={item.cartItemId} {...item} />
            ))}
          </ul>
          <Summary url={url} />
        </div>
      )}
    </div>
  );
};

export const DesktopBasket = connect<MergedProps, OwnProps>(
  state => ({
    quantity: getCartItemQuantity(state),
    url: getCheckoutLink(state),
    cartItems: state.cart.cartItems,
    isOpen: state.basket.isOpen
  }),
  dispatch => ({
    open: () => dispatch(basketOpen()),
    close: () => dispatch(basketClose())
  })
)(_DesktopBasket);
